import React, { useEffect, useRef, useState } from "react";
import { Button, Checkbox, Form, Input, InputNumber, Modal, Select, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import VerificationModal from "./VerificationModal";
import {
  setSinglePaymentObj,
  setWalletObj,
} from "../../../../features/obj/objSlice";
import {
  fetchBanks,
  fetchData,
  fetchFundsTransfer,
  fetchMainWallet,
  fetchPaymentModes,
  fetchSubwallet,
  fetchSubwalletDropdown,
} from "../../../../features/fetch/fetchSlice";
import { save } from "../../../../features/save/saveSlice";
import TransferModal from "../../../funds-transfer/modal/TransferModal";
import PhoneInput from "react-phone-input-2";
import CategoryAdd from "../../../setup/category/modal/CategoryAdd";
import SubCategoryAdd from "../../../setup/sub-category/modal/SubCategoryAdd";

const { TextArea } = Input;

const BankPaymentModal = ({
  open,
  handleCancel,
  handleFetchData,
  setopenSingle,
}) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { banks, paymentModes, dropLoading, mainWalletData, subwalletData } =
    useSelector((state) => state.fetch);
  const { saving } = useSelector((state) => state.save);
  const { user } = useSelector((state) => state.auth);
  const urlCat = "api/v1/payments/fetch-payment-categories";
  const urlSubCat = "api/v1/payments/fetch-sub-categories";

  const { loading, dataCat, dataSubCat } = useSelector((state) => ({
    loading: state.fetch.loading,
    dataCat: state.fetch.data[urlCat] || [],
    dataSubCat: state.fetch.data[urlSubCat] || [],
  }));

  const [paymentSourceName, setPaymentSourceName] = useState();
  const [paymentModeName, setPaymentModeName] = useState();
  const [bankName, setBankName] = useState();
  const [bankCode, setBankCode] = useState();
  const [accntNumber, setAccntNumber] = useState();
  const [categoryName, setCategoryName] = useState();
  const [subCategoryName, setSubCategoryName] = useState();

  const [openVerification, setopenVerification] = useState(false);

  const [openCategory, setopenCategory] = useState(false);
  function handleCancelCategory() {
    setopenCategory(false);
  }

  const [openSubCategory, setopenSubCategory] = useState(false);
  function handleCancelSubCategory() {
    setopenSubCategory(false);
  }

  const [isAccountValidated, setIsAccountValidated] = useState(false);

  async function handleCancelVerification() {
    await setopenVerification(false);
    await setopenSingle(true);
  }
  async function handleOpenVerification() {
    await setopenVerification(true);
    await setopenSingle(false);
    await handleCancel();
  }

  const [formData, setFormData] = useState();
  const [selectedWallet, setSelectedWallet] = useState(null);
  const [enteredAmount, setEnteredAmount] = useState(null);

  async function handleCancelSingle() {
    await handleCancel();
    await form.resetFields();
    await setSubCategoryName();
    await setCategoryName();
    await setEnteredAmount(null);
    await setSelectedWallet(null);
    await setIsAccountValidated(false);
  }

  const [openTransfer, setOpenTransfer] = useState(false);
  const handleOpenTransfer = async () => {
    await setOpenTransfer(true);
    await handleCancel();
  };
  const handleCancelTransfer = async () => {
    await setOpenTransfer(false);
    await setopenSingle(true);
  };

  const onFinish = async (data) => {
    data.pyType = "BANK";
    data.paymentSourceName = paymentSourceName;
    data.paymentModeName = paymentModeName;
    data.bankName = bankName;
    data.categoryName = categoryName;
    data.subCategoryName = subCategoryName;
    await dispatch(setSinglePaymentObj(data));
    await handleOpenVerification();
  };

  async function fetchBanksData() {
    await dispatch(
      fetchBanks({
        url: "api/v1/payments/fetch-banks",
      })
    );
  }

  async function handleValidValidate() {
    if (!bankCode) {
      toast.error("Please select a bank");
      return;
    }
    if (!accntNumber) {
      toast.error("Please provide a bank number");
      return;
    }
    if (bankCode && accntNumber) {
      const res = await dispatch(
        save({
          url: "api/v1/payments/validate-account",
          bankCode: bankCode,
          beneficiaryAccount: accntNumber,
        })
      );
      if (res?.payload?.data?.result?.status === "SUCCESS") {
        form.setFieldsValue({
          payBeneficiaryDetails: res?.payload?.data?.result?.benName,
        });
        setIsAccountValidated(true);
      } else {
        await form.setFieldsValue({
          payBeneficiaryDetails: null,
        });
        await setIsAccountValidated(false);
        await toast.error("Account not found type the account name");
      }
    }
  }

  const handleViewWallet = async (item) => {
    await dispatch(setWalletObj(item));
    await navigate("/my-wallet-view");
  };

  const handleTransfer = async (item) => {
    await handleOpenTransfer();
  };

  async function fetchSubWalletData() {
    dispatch(
      fetchSubwalletDropdown({
        url: `api/v1/wallet/sub/${user?.disbursementWalId}`,
      })
    );
  }

    async function fetchCategoryData() {
      dispatch(
        fetchData({
          url: urlCat,
          start: 0,
          limit: null,
        })
      );
    }


  async function fetchSubCategoryData(value) {
    dispatch(
      fetchData({
        url: urlSubCat,
        pcId: value,
      })
    );
  }
  async function fetchFundsTransferData() {
    dispatch(
      fetchFundsTransfer({
        url: "api/v1/wallet/fetch-fund-transfers",
        limit: null,
        start: 0,
        transaStatus: null,
        transaSourceWallet: null,
      })
    );
  }

  async function fetchPaymentModesData() {
    await dispatch(
      fetchPaymentModes({
        url: "api/v1/payments/fetch-payment-modes",
        pmType: "BANK",
      })
    );
  }

  useEffect(() => {
    if (open) {
      fetchPaymentModesData();
    }
  }, [open]);

  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={`Direct Payment`}
        open={open}
        onOk={onFinish}
        onCancel={handleCancelSingle}
        width={850}
        maskClosable={false}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
          // initialValues={singlePaymentObj}
        >
          <div className="grid lg:grid-cols-2 lg:gap-x-5 grid-cols-1">
            <Form.Item
              name="pyPmId"
              className=""
              label={<span>Payment Mode</span>}
              rules={[
                {
                  required: true,
                  message: "Please select Payment Mode",
                },
              ]}
            >
              <Select
                className=""
                allowClear
                style={{
                  width: "100%",
                }}
                options={
                  paymentModes?.length > 0 &&
                  paymentModes?.map((item) => ({
                    value: item?.pmId,
                    label: item?.pmName,
                  }))
                }
                onChange={(value) => {
                  const selectedItem = paymentModes?.find(
                    (item) => item?.pmId === value
                  );
                  setPaymentModeName(selectedItem?.pmName || "");
                  form.resetFields(["payReceiverMobileNo"]);
                  form.resetFields(["payBnkId"]);
                  form.resetFields(["payBeneficiaryAccount"]);
                  form.resetFields(["payBeneficiaryDetails"]);
                  setIsAccountValidated(false);
                }}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase()
                  )
                }
              />
            </Form.Item>
            <Form.Item
              name="pyWalId"
              className=""
              label={<span>Payment Source</span>}
              rules={[
                {
                  required: true,
                  message: "Please select payment source",
                },
              ]}
            >
              <Select
                className=""
                allowClear
                style={{
                  width: "100%",
                }}
                options={
                  subwalletData?.length > 0 &&
                  subwalletData?.map((item) => ({
                    value: item?.walId,
                    label:
                      item?.walName +
                      " - " +
                      item?.walCode +
                      " - " +
                      item?.walCurrency +
                      " " +
                      item?.walAvailableBalance,
                  }))
                }
                notFoundContent={
                  <div
                    onClick={() => navigate("/my-wallet")}
                    className="cursor-pointer text-ndovuRed"
                  >
                    Assign wallet to this user
                  </div>
                }
                onChange={(value) => {
                  const selectedItem = subwalletData?.find(
                    (item) => item?.walId === value
                  );
                  setSelectedWallet(selectedItem || null);
                  setEnteredAmount(null);
                  setPaymentSourceName(selectedItem?.walName || "");
                }}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase()
                  )
                }
                onDropdownVisibleChange={() => {
                  fetchSubWalletData();
                }}
                dropdownRender={(menu) => (
                  <>
                    {dropLoading && (
                      <div
                        style={{
                          padding: "8px",
                          textAlign: "center",
                        }}
                      >
                        <Spin className="sms-spin" />
                      </div>
                    )}
                    {menu}
                  </>
                )}
              />
            </Form.Item>

            <Form.Item
              name="pyPcId"
              className=""
              label={<span>Category</span>}
              rules={[
                {
                  required: false,
                  message: "Please select payment category",
                },
              ]}
            >
              <Select
                className=""
                allowClear
                style={{
                  width: "100%",
                }}
                options={
                  dataCat?.length > 0 &&
                  dataCat?.map((item) => ({
                    value: item?.pcId,
                    label: item?.pcName,
                  }))
                }
                onChange={(value) => {
                  fetchSubCategoryData(value);
                  const selectedItem = dataCat?.find(
                    (item) => item?.pcId === value
                  );
                  setCategoryName(selectedItem?.pcName || "");
                  form.resetFields(["pyPscId"]);
                }}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase()
                  )
                }
                dropdownRender={(menu) => (
                  <>
                    {menu}
                    <div style={{ padding: 8 }}>
                      <Button
                        type="link"
                        onClick={() => setopenCategory(true)}
                        style={{ padding: 0 }}
                      >
                        + Add new Category
                      </Button>
                    </div>
                  </>
                )}
              />
            </Form.Item>
            {categoryName && (
              <Form.Item
                name="pyPscId"
                className=""
                label={<span>Sub Category</span>}
                rules={[
                  {
                    required: true,
                    message: "Please select payment sub-category",
                  },
                ]}
              >
                <Select
                  className=""
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  options={
                    dataSubCat?.length > 0 &&
                    dataSubCat?.map((item) => ({
                      value: item?.pscId,
                      label: item?.pscName,
                    }))
                  }
                  onChange={(value) => {
                    const selectedItem = dataSubCat?.find(
                      (item) => item?.pscId === value
                    );
                    setSubCategoryName(selectedItem?.pscName || "");
                  }}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label?.toLocaleLowerCase() ?? "").includes(
                      input?.toLocaleLowerCase()
                    )
                  }
                  dropdownRender={(menu) => (
                    <>
                      {menu}
                      <div style={{ padding: 8 }}>
                        <Button
                          type="link"
                          onClick={() => setopenSubCategory(true)}
                          style={{ padding: 0 }}
                        >
                          + Add new Sub-Category
                        </Button>
                      </div>
                    </>
                  )}
                />
              </Form.Item>
            )}

            <Form.Item
              extra={
                selectedWallet &&
                enteredAmount &&
                Number(selectedWallet?.walAvailableBalance) <
                  Number(enteredAmount) && (
                  <div className="text-[#2563EB] text-[.85rem] font-[400] leading-[1.5rem] gap-[.3rem]  flex items-center">
                    {selectedWallet?.walType === "DISBURSEMENT"
                      ? "Insufficient funds please do wallet transfer."
                      : selectedWallet?.walType === "COLLECTION"
                      ? "Insufficient funds please top up to proceed."
                      : null}
                    <span
                      className="text-[#1F54C8] text-[.85rem] font-[500] cursor-pointer"
                      onClick={() =>
                        selectedWallet?.walType === "DISBURSEMENT"
                          ? handleTransfer()
                          : selectedWallet?.walType === "COLLECTION"
                          ? handleViewWallet(selectedWallet)
                          : null
                      }
                    >
                      {selectedWallet?.walType === "DISBURSEMENT"
                        ? "+Transfer"
                        : selectedWallet?.walType === "COLLECTION"
                        ? "+Top Up Amount"
                        : null}
                    </span>
                  </div>
                )
              }
              name="payPaymentAmount"
              label="Amount"
              rules={[
                {
                  required: true,
                  message: "Enter amount",
                },
              ]}
            >
              <InputNumber
                min={10}
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                placeholder="Enter amount"
                className="input flex"
                onChange={(value) => setEnteredAmount(value)}
              />
            </Form.Item>
            <Form.Item
              name="payIdNumber"
              label="National ID"
              rules={[
                {
                  required: false,
                  message: "Recepient National ID is required",
                },
                {
                  validator(_, value) {
                    if (value && value.toString().length < 6) {
                      return Promise.reject(
                        "National ID must be at least 6 characters long"
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <InputNumber
                min={0}
                parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                className="input flex"
              />
            </Form.Item>
            {(paymentModeName === "PESALINK_MPESA" ||
              paymentModeName === "PESALINK_BANK") && (
              <Form.Item
                className="table-form-item"
                name="payReceiverMobileNo"
                label="Receiver Number"
                rules={[
                  {
                    required: true,
                    message: "Please add Receiver Number",
                  },
                  {
                    validator: (_, value) => {
                      if (value && value.length === 12) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("Phone number must be exactly 10 characters")
                      );
                    },
                  },
                ]}
              >
                <PhoneInput
                  country="ke"
                  countryCodeEditable={false}
                  className="input"
                />
              </Form.Item>
            )}
          </div>
          {paymentModeName === "PESALINK_BANK" && (
            <>
              {" "}
              <div className="flex items-center lg:gap-x-5">
                <Form.Item
                  name="payBnkId"
                  className="w-full"
                  label={<span>Bank</span>}
                  rules={[
                    {
                      required: true,
                      message: "Please select Bank",
                    },
                  ]}
                >
                  <Select
                    className=""
                    allowClear
                    style={{
                      width: "100%",
                    }}
                    options={
                      banks?.length > 0 &&
                      banks?.map((item) => ({
                        value: item?.bnkId,
                        label: item?.bnkName,
                      }))
                    }
                    onChange={(value) => {
                      const selectedItem = banks?.find(
                        (item) => item?.bnkId === value
                      );
                      setBankName(selectedItem?.bnkName || "");
                      setBankCode(selectedItem?.bnkNo || "");
                      setIsAccountValidated(false);
                      form.setFieldsValue({
                        payBeneficiaryDetails: null,
                      });
                    }}
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      (option?.label?.toLocaleLowerCase() ?? "").includes(
                        input?.toLocaleLowerCase()
                      )
                    }
                    onDropdownVisibleChange={() => {
                      fetchBanksData();
                    }}
                    dropdownRender={(menu) => (
                      <>
                        {dropLoading && (
                          <div
                            style={{
                              padding: "8px",
                              textAlign: "center",
                            }}
                          >
                            <Spin className="sms-spin" />
                          </div>
                        )}
                        {menu}
                      </>
                    )}
                  />
                </Form.Item>

                <Form.Item
                  className="w-full"
                  name="payBeneficiaryAccount"
                  label="Account Number"
                  rules={[
                    {
                      required: true,
                      message: "Enter Account Number",
                    },
                  ]}
                >
                  <Input
                    onChange={(e) => {
                      setAccntNumber(e.target.value);
                      setIsAccountValidated(false);
                      form.setFieldsValue({
                        payBeneficiaryDetails: null,
                      });
                    }}
                    className="input"
                  />
                </Form.Item>

                <div className="w-[100px]">
                  <button
                    type="button"
                    className="cstm-btn-2 !rounded-[10px]"
                    disabled={saving}
                    onClick={handleValidValidate}
                  >
                    {saving ? <Spin /> : "Validate"}
                  </button>
                </div>
              </div>
              <Form.Item
                name="payBeneficiaryDetails"
                label="Account Name"
                rules={[
                  {
                    required: true,
                    message: "Enter Account Name",
                  },
                ]}
              >
                <Input disabled className="input" />
              </Form.Item>
            </>
          )}

          <Form.Item
            name="payPaymentReason"
            label="Reason for transfer"
            rules={[
              {
                required: true,
                message: "Enter reason for transfer",
              },
            ]}
          >
            <TextArea
              rows={4}
              placeholder="Enter reason for transfer"
              className="input-textarea"
            />
          </Form.Item>
          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancelSingle}
                  className="cstm-btn"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className={`cstm-btn-2 ${
                    (Number(selectedWallet?.walAvailableBalance) <
                      Number(enteredAmount) ||
                      (paymentModeName === "PESALINK_BANK" &&
                        !isAccountValidated)) &&
                    "!cursor-not-allowed"
                  }`}
                  disabled={
                    saving ||
                    Number(selectedWallet?.walAvailableBalance) <
                      Number(enteredAmount) ||
                    (paymentModeName === "PESALINK_BANK" && !isAccountValidated)
                  }
                >
                  {saving ? <Spin /> : "Next"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
      <VerificationModal
        handleFetchData={handleFetchData}
        open={openVerification}
        setopenVerification={setopenVerification}
        handleCancel={handleCancelVerification}
        handleCancelSingle={handleCancel}
      />
      <TransferModal
        handleFetchData={fetchFundsTransferData}
        open={openTransfer}
        setopenSingle={setOpenTransfer}
        handleCancel={handleCancelTransfer}
      />
      <CategoryAdd
        isModalOpen={openCategory}
        handleCancel={handleCancelCategory}
        handleFetch={fetchCategoryData}
        prodd=""
      />
      <SubCategoryAdd
        isModalOpen={openSubCategory}
        handleCancel={handleCancelSubCategory}
        handleFetch={() => fetchSubCategoryData(form.getFieldValue("pyPcId"))}
        prodd={
          form.getFieldValue("pyPcId")
            ? { pcId: form.getFieldValue("pyPcId") }
            : null
        }
      />
    </>
  );
};
export default BankPaymentModal;
